import { getCurrencySymbol } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import type { Currency, PaymentInterval } from '@core/billing-types';
import { TranslatePipe } from '@core/i18n-legacy';

@Component({
  selector: 'rt-plan-picker-2024-product-price',
  templateUrl: './plan-picker-2024-product-price.component.html',
  styleUrls: ['./plan-picker-2024-product-price.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class PlanPicker2024ProductPriceComponent {
  public readonly interval = input<PaymentInterval>(undefined!);
  public readonly currency = input<Currency>(undefined!);
  public readonly costPerMonth = input<number>(undefined!);
  public readonly costPerYear = input<number>(undefined!);

  public currencySymbol: string;
  public yearCost: string;
  public monthCost: string;

  public ngOnChanges() {
    this.currencySymbol = getCurrencySymbol(this.currency(), 'narrow');
    this.yearCost = this.YearCost;
    this.monthCost = this.MonthCost;
  }

  private get YearCost() {
    return this.currencySymbol + Math.ceil(this.costPerYear() / 12);
  }

  private get MonthCost() {
    return this.currencySymbol + Math.ceil(this.costPerMonth());
  }
}
